import React from "react";
import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";

const QUESTIONS = [
  {
    q: "Combien de temps dure l'expérience complète ?",
    a: "Environ 35 minutes au total, en quatre pistes que tu peux écouter séparément ou enchaîner. Le plus important n'est pas la durée, mais la régularité d'écoute.",
  },
  {
    q: "Est-ce que c'est fait pour moi si je doute beaucoup ?",
    a: "Oui, c'est précisément la porte d'entrée. L'expérience est pensée pour les personnes qui ont déjà beaucoup travaillé sur elles et qui sentent que ce n'est plus le mental qu'il faut convaincre — c'est une partie plus profonde.",
  },
  {
    q: "Est-ce que je peux l'écouter plusieurs fois ?",
    a: "Oui, et c'est même conseillé. Chaque écoute touche une couche différente. Tu as un accès à vie pour revenir aussi souvent que tu en as besoin.",
  },
  {
    q: "Est-ce que c'est une formation ?",
    a: "Non. Ce n'est ni un cours, ni un coaching. C'est une expérience sonore guidée, une capsule à vivre — pas à étudier.",
  },
  {
    q: "Est-ce que j'y ai accès immédiatement ?",
    a: "Oui. Dès le paiement validé, tu reçois un e-mail avec ton accès aux quatre pistes et au protocole d'intégration.",
  },
  {
    q: "Est-ce que ça remplace un suivi thérapeutique ?",
    a: "Non. Cette expérience est un support de développement personnel. Elle ne remplace pas un accompagnement médical, psychologique ou thérapeutique si tu en as besoin.",
  },
];

export default function Faq() {
  return (
    <section
      data-testid="faq-section"
      id="faq"
      className="relative py-24 md:py-36 px-6 md:px-10 bg-obsidian-surface/40"
    >
      <div className="max-w-4xl mx-auto">
        <div className="mb-16 md:mb-20">
          <p className="text-xs tracking-[0.35em] uppercase text-gold mb-6">
            07 · Questions
          </p>
          <h2 className="font-display uppercase text-4xl md:text-6xl lg:text-7xl leading-[0.95] tracking-[-0.02em]">
            Quelques{" "}
            <span className="font-serif italic font-light text-gold normal-case lowercase">
              précisions.
            </span>
          </h2>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
        >
          <Accordion type="single" collapsible className="w-full">
            {QUESTIONS.map((item, i) => (
              <AccordionItem
                key={i}
                value={`q-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-white/5 last:border-b-0"
              >
                <AccordionTrigger className="font-display text-lg md:text-2xl text-ink-50 py-7 hover:text-gold transition-colors text-left tracking-tight hover:no-underline">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="font-serif text-base md:text-lg text-ink-400 leading-relaxed pb-7">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
